import { React } from 'react';

const PreviewImage = ({ setLoadCounter, value, TickerStart, TickerPosition, zInd, CanvasDisplay }) => {


    const isLoaded = () => {

        if (sessionStorage.getItem("LoadCounter")) {
            let array = JSON.parse(sessionStorage.getItem("LoadCounter"));
            array.push(value.previewKey);
            sessionStorage.setItem("LoadCounter", JSON.stringify(array));
            setLoadCounter(array);
        }

    }


    return (<>
        {!value.startAtoZ && value.opc === 1 && (
            <div className={"changer " + value.InClass + value.OutClass}
                id={"Preview-"+ value.AnimationId}
                style={{
                    'VendorAnimationDuration': '.5s',
                    display: (!CanvasDisplay ? value.player ? 'inline-block' : 'none' :
                        TickerStart ?
                            (value.startPositionOnTimeline <= TickerPosition && (value.startPositionOnTimeline + value.widthOnTimeline) >= TickerPosition) ? 'inline-block' : 'none' :
                            (value.startPositionOnTimeline + value.startTransitionWidth <= TickerPosition && (value.startPositionOnTimeline + value.widthOnTimeline - value.startTransitionWidth) >= TickerPosition) ? 'inline-block' :
                                'none'),

                    width: value.width, height: value.height,
                    zIndex: zInd, 
                    //transform: `rotate(${value.rotateAngle}deg)`,
                    left: value.x, top: value.y, position: 'absolute'
                }}
            >
                <div className={('') + "DivTag"} draggable={false} style={{
                    //transform: CanvasDisplay ? `rotate(${value.rotateAngle}deg) ` + value.flip : value.flip
                }}>
                    <img className="ImgTag" onLoad={isLoaded}
                        onError={() => {
                            // A picture that cannot be loaded must not keep the preview loading forever.
                            console.warn("Preview: picture could not be loaded:", String(value.ImageSrc).slice(0, 200));
                            isLoaded();
                        }}
                        style={{
                            transform: `rotate(${value.rotateAngle}deg) ` + value.flip,
                            opacity: value.opacity
                        }}
                        draggable={false}
                        src={value.ImageSrc}
                    />
                </div>
            </div>
        )}
    </>
    );
};

export default PreviewImage;